import 'core-js/stable';
import 'react-app-polyfill/ie11';
import * as React from "react";
import * as ReactDOM from 'react-dom';
import {Component} from "react";
import App from "./app";

import "bootstrap/dist/css/bootstrap.min.css";
import "./css/style.scss";

ReactDOM.render(
  <App/>,
  document.getElementById('app')
);
